import React, { Fragment, useEffect, useState } from 'react'
import { Order } from '../../../types/Order'
import styles from './FulfillmentList.module.css'
import cx from 'classnames'
import Card from '../../../components/Card'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useFetchData } from '../../../hooks/useFetchData'
import { ApiRoutes } from '../../../services/ApiService'
import Pagination from '../../../components/Pagination'
import Loader from '../../../components/Loader'

const FulfillmentList: React.FC = () => {
    const { t } = useTranslation(['fulfillment'])
    const navigate = useNavigate()

    const [page, setPage] = useState<number>(1)

    const {
        data: orders,
        fetch,
        isLoading,
        pagination,
    } = useFetchData<Order>(ApiRoutes.ORDERS)

    useEffect(() => {
        fetch({
            page: page.toString(),
            perPage: '10',
        })
    }, [fetch, page])

    return !isLoading ? (
        <Fragment>
            <div className={cx(styles['fulfillment-list'])}>
                {orders.map((order) => (
                    <Card
                        key={order.id}
                        classes={cx(styles['fulfillment-item-card'])}
                    >
                        <div className={cx(styles['fulfillment-item'])}>
                            <div className={'zr-flex zr-flex-col'}>
                                <div
                                    className={cx(
                                        styles['fulfillment-item-header']
                                    )}
                                >
                                    {t('list.no')}
                                </div>
                                <div>{order.number}</div>
                            </div>
                            <div className={'zr-flex zr-flex-col'}>
                                <div
                                    className={cx(
                                        styles['fulfillment-item-header']
                                    )}
                                >
                                    {t('list.customer')}
                                </div>
                                <div>
                                    {order.customer.firstname}{' '}
                                    {order.customer.lastname}
                                </div>
                            </div>
                            <div className={'zr-flex zr-flex-col'}>
                                <div
                                    className={cx(
                                        styles['fulfillment-item-header']
                                    )}
                                >
                                    {t('list.date')}
                                </div>
                                <div>{order.datetime}</div>
                            </div>
                            <div className={'zr-flex zr-flex-col'}>
                                <div
                                    className={cx(
                                        styles['fulfillment-item-header']
                                    )}
                                >
                                    {t('list.status')}
                                </div>
                                <div>{order.status}</div>
                            </div>
                            <div className={'zr-flex zr-flex-col'}>
                                <div
                                    className={cx(
                                        styles['fulfillment-item-header']
                                    )}
                                >
                                    {t('list.count')}
                                </div>
                                <div>{order.customizations.length}</div>
                            </div>
                        </div>
                        <div
                            className={cx(
                                styles['fulfillment-item-header'],
                                'zr-mb-2'
                            )}
                        >
                            {t('list.customizations')}
                        </div>
                        <div className={'zr-flex zr-row zr-gap-2'}>
                            <button
                                className={cx(
                                    styles['fulfillment-customization']
                                )}
                                onClick={() =>
                                    navigate(
                                        `/fulfillment/orders/${order.number}`
                                    )
                                }
                            >
                                {t('list.show_all')}
                            </button>
                            {order.customizations.map((customization) => (
                                <button
                                    key={customization.id}
                                    className={cx(
                                        styles['fulfillment-customization']
                                    )}
                                    onClick={() => {
                                        navigate(
                                            `/fulfillment/customizations/${customization.id}`
                                        )
                                    }}
                                >
                                    #{customization.id}
                                </button>
                            ))}
                        </div>
                    </Card>
                ))}
            </div>
            {pagination && pagination.lastPage > 1 && (
                <Pagination
                    totalPages={pagination.lastPage}
                    currentPage={pagination.currentPage}
                    onPageChange={(p) => setPage(p)}
                />
            )}
        </Fragment>
    ) : (
        <div className={'zr-w-100 zr-d-flex zr-justify-center'}>
            <Loader isLoading={isLoading} />
        </div>
    )
}

export default FulfillmentList
